import React from "react";
import { Package, ChevronDown, Award } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { packageUrl } from "@/lib/api";

export default function DownloadPackageMenu({ tenderId, solvency }) {
    const hasSolvency = !!solvency?.has_data;
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    className="rounded-xl border-slate-300 h-9 gap-1.5"
                    data-testid="download-package-btn"
                >
                    <Package size={14} />
                    Descargar paquete
                    <ChevronDown size={12} className="opacity-60" />
                </Button>
            </PopoverTrigger>
            <PopoverContent
                align="end"
                className="w-80 p-2 rounded-2xl shadow-pop"
                data-testid="download-package-popover"
            >
                <a
                    href={packageUrl(tenderId)}
                    download
                    className="flex items-start gap-3 p-3 rounded-xl hover:bg-ink-50 transition-colors group"
                    data-testid="download-package-plain"
                >
                    <Package
                        size={18}
                        className="text-ink-600 shrink-0 mt-0.5"
                    />
                    <div className="flex-1 min-w-0">
                        <div className="text-sm font-bold text-ink-950">
                            Solo licitación
                        </div>
                        <div className="text-[11px] text-ink-500 font-medium leading-tight mt-0.5">
                            Pliegos · análisis · escandallo · anexos
                        </div>
                    </div>
                </a>
                <a
                    href={packageUrl(tenderId, { includeSolvency: true })}
                    download
                    className={`flex items-start gap-3 p-3 rounded-xl transition-colors group ${
                        hasSolvency
                            ? "hover:bg-gradient-to-r hover:from-amber-50 hover:to-orange-50"
                            : "opacity-60 pointer-events-none cursor-not-allowed"
                    }`}
                    title={
                        hasSolvency
                            ? "Adjunta cuadros LCSP de solvencia"
                            : "Sube primero documentos en /app/solvencia"
                    }
                    data-testid="download-package-with-solvency"
                    onClick={(e) => {
                        if (!hasSolvency) e.preventDefault();
                    }}
                >
                    <Award
                        size={18}
                        className="text-amber-600 shrink-0 mt-0.5"
                    />
                    <div className="flex-1 min-w-0">
                        <div className="text-sm font-bold text-ink-950 flex items-center gap-1.5">
                            Con cuadros de solvencia
                            {hasSolvency && (
                                <span className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded-full bg-amber-100 text-amber-700">
                                    LCSP Art. 87-90
                                </span>
                            )}
                        </div>
                        <div className="text-[11px] text-ink-500 font-medium leading-tight mt-0.5">
                            {hasSolvency
                                ? `Añade PDF + Excel con ${solvency.tecnica_count} servicio${solvency.tecnica_count === 1 ? "" : "s"} y ${solvency.economica_count} dato${solvency.economica_count === 1 ? "" : "s"} económicos`
                                : "Sube primero facturas o cuentas anuales"}
                        </div>
                    </div>
                </a>
            </PopoverContent>
        </Popover>
    );
}
